import { KeyboardEvent, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { SignUpFormContext } from "../sign-up-form.context";
import { InlineAlertComponent, TextFieldComponent } from "@gx1/gx-ui-common";
import { useSignupToken } from "../../hooks/use-signup-token.hook";
import ValidatePassword from "../validate-password/validate-password.component";
import styles from "./sign-up-form-fields.styles.module.scss";

const SignUpFormFields = () => {
  const { t } = useTranslation();
  const { decodedToken } = useSignupToken();
  const {
    email,
    errorText,
    firstName,
    isBreachedPassword,
    isValidPwd,
    lastName,
    password,
    termsPolicyAgreement,
    setEmail,
    setErrorText,
    setFirstName,
    setIsCompleteSignUpForm,
    setLastName,
  } = useContext(SignUpFormContext);

  useEffect(() => {
    setEmail(decodedToken.email);
  }, [decodedToken, setEmail]);

  useEffect(() => {
    if (email && firstName && lastName && isValidPwd && termsPolicyAgreement && !errorText) {
      setIsCompleteSignUpForm(true);
    } else {
      setIsCompleteSignUpForm(false);
    }
  }, [email, firstName, lastName, isValidPwd, termsPolicyAgreement, setIsCompleteSignUpForm, errorText]);

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event?.key !== "Enter") {
      return;
    }
    event?.preventDefault();
    if (!(firstName && lastName && password)) {
      setErrorText(t("Please fill out all fields."));
    } else {
      setErrorText("");
    }
  };

  return (
    <div className={styles.root}>
      <div className={styles.nameContainer}>
        <TextFieldComponent
          rootClassName={styles.textField}
          onChange={(e) => setFirstName(e.target.value)}
          placeholder={t("First Name")}
          onKeyDown={handleKeyDown}
          value={firstName}
        />
        <TextFieldComponent
          rootClassName={styles.textField}
          onChange={(e) => setLastName(e.target.value)}
          placeholder={t("Last Name")}
          onKeyDown={handleKeyDown}
          value={lastName}
        />
      </div>
      <div>
        <TextFieldComponent placeholder={t("Email")} value={email} isDisabled={true} />
      </div>
      {isBreachedPassword &&
          <InlineAlertComponent
            variant={"error"}
            message={t("Passwords cannot contain words that were in a previous password breach.")}
          />
      }
      <ValidatePassword />
    </div>
  );
};

export default SignUpFormFields;
